export const mapLicDetails = (resp) => {
    console.log("klic",resp)
 return   { id: {id  :resp.licId, name : resp.licno} || "",

    name: resp.licno || "",
    licRefNo: resp.licRefNo || "null" }
    
  };